import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const BenchmarkGate = React.lazy(() => import("./Benchmark.gate"));

const BenchmarkLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <BenchmarkGate />
  </React.Suspense>
);

export default () => <BenchmarkLoadable />;
